export default __webpack_public_path__ + "static/media/rank-up-arrow-icon.e9798823.svg";